
export default {
	name: "Literature",
};
